import { ref } from 'vue';
import { useEventListener } from './useEventListener';
import fastdom from 'fastdom';


export const useWindowSize = ({
    includeScrollbar = true,
}) => {
    const width = ref(0);
    const height = ref(0);

    const update = () => {
        fastdom.measure(() => {
            width.value = includeScrollbar ? window.innerWidth : document.documentElement.clientWidth;
            height.value = includeScrollbar ? window.innerHeight : document.documentElement.clientHeight;
        });
    };

    update();

    useEventListener('resize', update, { passive: true });

    return {
        width,
        height,
    }
}
